import { ComponentIds, HierarchyUtils } from '@inter-ikea-core/core';
import { PlannerEcsMultiSystem } from './System';
import HelpLinesBoxColliderComponent from '../components/HelpLinesBoxColliderComponent';
import HelpLinesColliderComponent from '../components/HelpLinesColliderComponent';
import CollisionComponent from '../components/CollisionComponent';
import ProductInfoComponent from '../components/ProductInfoComponent';
import { PartKey, ProductType } from '../../types';
import { isAssembly } from '../resolvers/common';
import EventComponent from '../components/EventComponent';
export class FunctionalMarginCollisionSystem extends PlannerEcsMultiSystem {
    constructor(coreApi) {
        super(coreApi, 'FunctionalMarginCollisionSystem', [
            EventComponent.id,
            ComponentIds.FUNCTIONAL_MARGIN_COMPONENT_ID
        ]);
    }
    onAdd(entity, newComponent) {
        if (newComponent.typeId === ComponentIds.FUNCTIONAL_MARGIN_COMPONENT_ID) {
            this.validateFramePlacements();
        }
    }
    onUpdate(entity, oldComponent, newComponent) {
        if (newComponent.typeId === EventComponent.id &&
            newComponent.event === 'history') {
            this.validateFramePlacements();
        }
    }
    onRemove(entity, oldComponent) {
        if (oldComponent.typeId === ComponentIds.FUNCTIONAL_MARGIN_COMPONENT_ID) {
            const colliderFrames = this.coreApi.entities
                .getByComponents([ComponentIds.COLLIDER_COMPONENT_ID, ComponentIds.FRAME_COMPONENT_ID])
                .filter(e => e.hasComponent(ComponentIds.FRAME_COMPONENT_ID));
            const validations = this.coreApi.getServices().validations;
            colliderFrames.forEach(frame => {
                const validationResult = validations.validateCurrentState(frame, false);
                if (validationResult.length === 0) {
                    if (frame.hasComponent(HelpLinesColliderComponent.id) &&
                        frame.hasComponent(ComponentIds.FRAME_COMPONENT_ID)) {
                        const allEntitiesToUnMarkRed = this.getAllCollisionEntities(frame);
                        allEntitiesToUnMarkRed.forEach(entity => {
                            entity.removeComponent(CollisionComponent.id);
                        });
                        frame.removeComponent(HelpLinesColliderComponent.id);
                    }
                }
            });
        }
    }
    getAllCollisionEntities(frameOrAssembly) {
        const childComponents = this.coreApi.entities
            .getFrameDescendants(frameOrAssembly)
            .filter(child => child.hasComponent(ComponentIds.LEG_COMPONENT_ID) ||
            child.hasComponent(ComponentIds.DOOR_FRONT_COMPONENT_ID) ||
            child.hasComponent(ComponentIds.HANDLE_COMPONENT_ID) ||
            child.getComponent(ProductInfoComponent.id)?.productType ===
                ProductType.PLATSA_DRAWER_FRONT ||
            child.getComponent(ProductInfoComponent.id)?.productType ===
                ProductType.SMASTAD_DOOR_FRONT ||
            child.getComponent(ProductInfoComponent.id)?.productType ===
                ProductType.SMASTAD_DRAWER_FRONT ||
            child.getComponent(ProductInfoComponent.id)?.productType ===
                ProductType.SMASTAD_BENCH_DRAWER ||
            child.getComponent(ProductInfoComponent.id)?.productType ===
                ProductType.SMASTAD_PULL_OUT_FRAME_DRAWER);
        if (isAssembly(frameOrAssembly)) {
            const assemblyFrames = HierarchyUtils.descendants(frameOrAssembly).filter(child => child.getComponent(ComponentIds.PRODUCT_PART_COMPONENT_ID)
                ?.partKey === PartKey.FRAME);
            if (assemblyFrames.length > 0) {
                childComponents.push(...assemblyFrames);
            }
        }
        return [frameOrAssembly, ...childComponents];
    }
    validateFramePlacements() {
        const frames = this.coreApi.entities.getByComponent(ComponentIds.FRAME_COMPONENT_ID);
        const validations = this.coreApi.getServices().validations;
        frames.forEach(frame => {
            const validationResult = validations.validateCurrentState(frame, false);
            validationResult.forEach((result) => {
                if (result.otherEntity?.hasComponent(HelpLinesBoxColliderComponent.id) &&
                    !frame.hasComponent(CollisionComponent.id)) {
                    frame.addComponent(new HelpLinesColliderComponent());
                    const allEntitiesToMarkRed = this.getAllCollisionEntities(frame);
                    allEntitiesToMarkRed.forEach(entity => {
                        entity.addComponent(new CollisionComponent());
                    });
                }
            });
        });
    }
}
//# sourceMappingURL=FunctionalMarginCollisionSystem.js.map